module.exports = __webpack_public_path__ + "static/who-we-are-detail-01.4ca3a3d2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/who-we-are-detail-01.svg
// module id = 1517
// module chunks = 169858455373905